<template>
  <div class="inspection-management">
    <div class="content">
      <el-card>
        <template #header>
          <div class="header-bar">
            <div class="header-left">
              <span class="title">验配单位管理</span>
              <template v-if="!isMobile">
                <!-- 管理员：采购单位 + 验配单位双条件搜索 -->
                <template v-if="isAdmin">
                  <el-input
                    v-model="searchPurchasingUnits"
                    placeholder="按采购单位搜索"
                    size="small"
                    clearable
                    class="header-search"
                  />
                  <el-input
                    v-model="searchOptometryClinic"
                    placeholder="按验配单位搜索"
                    size="small"
                    clearable
                    class="header-search"
                  />
                </template>
                <!-- 普通用户：验配单位搜索 -->
                <el-input
                  v-else
                  v-model="searchOptometryClinic"
                  placeholder="按验配单位搜索"
                  size="small"
                  clearable
                  class="header-search"
                />
              </template>
            </div>
            <template v-if="!isMobile">
              <el-button
                type="primary"
                size="small"
                class="header-add-btn"
                @click="openAddDialog"
              >新增验配单位</el-button>
            </template>
          </div>
        </template>
        
        <!-- 桌面和平板端显示 -->
        <div class="table-responsive desktop-table" v-if="!isMobile">
          <el-table :data="inspectionList" style="width: 100%" v-loading="loading" border>
            <el-table-column label="序号" width="70" align="center" fixed="left">
              <template #default="scope">
                {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
              </template>
            </el-table-column>
            <el-table-column prop="username" label="用户名" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="purchasingUnits" label="采购单位" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="optometryClinic" label="验配单位" min-width="250" show-overflow-tooltip>
              <template #default="scope">
                <span class="optometry-clinic-text">{{ scope.row.optometryClinic }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" min-width="160">
              <template #default="scope">
                {{ formatDate(scope.row.updatedAt) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center" fixed="right">
              <template #default="scope">
                <div class="action-buttons">
                  <el-button
                      size="small"
                      type="primary"
                      @click="openEditDialog(scope.row)">
                    修改
                  </el-button>
                  <el-button
                      size="small"
                      type="danger"
                      @click="handleDelete(scope.row)">
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <!-- 手机端卡片式布局 -->
        <div class="mobile-cards" v-else>
          <!-- 移动端新增按钮 -->
          <el-button
            type="primary"
            size="default"
            style="width: 100%; margin-bottom: 10px;"
            @click="openAddDialog"
          >新增验配单位</el-button>
          <!-- 移动端：管理员双条件搜索 -->
          <template v-if="isAdmin">
            <el-input
              v-model="searchPurchasingUnits"
              placeholder="按采购单位搜索"
              size="default"
              clearable
              style="margin-bottom: 10px"
            />
            <el-input
              v-model="searchOptometryClinic"
              placeholder="按验配单位搜索"
              size="default"
              clearable
              style="margin-bottom: 10px"
            />
          </template>
          <el-input
            v-else
            v-model="searchOptometryClinic"
            placeholder="按验配单位搜索"
            size="default"
            clearable
            style="margin-bottom: 10px"
          />
          <div v-if="loading" class="loading-container">
            <el-icon class="is-loading"><Loading /></el-icon>
            <span>加载中...</span>
          </div>
          <div v-else>
            <div class="inspection-card" v-for="(item, index) in inspectionList" :key="item.id">
              <div class="card-info">
                <div class="card-header">
                  <span class="card-title">验配单位</span>
                  <el-tag size="small" type="info">序号: {{ index + 1 + (currentPage - 1) * pageSize }}</el-tag>
                </div>
                <div class="card-details">
                  <div class="detail-item">
                    <span class="label">用户名:</span>
                    <span class="value">{{ item.username }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">采购单位:</span>
                    <span class="value">{{ item.purchasingUnits }}</span>
                  </div>
                  <div class="detail-item highlight">
                    <span class="label">验配单位:</span>
                    <span class="value optometry-clinic-text">{{ item.optometryClinic }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="label">更新时间:</span>
                    <span class="value">{{ formatDate(item.updatedAt) }}</span>
                  </div>
                </div>
              </div>
              <div class="card-actions">
                <el-button
                  size="small"
                  type="primary"
                  @click="openEditDialog(item)"
                  style="flex: 1; margin-right: 5px;">
                  修改
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="handleDelete(item)"
                  style="flex: 1;">
                  删除
                </el-button>
              </div>
            </div>
            <el-empty v-if="inspectionList.length === 0" description="没有找到验配单位数据"></el-empty>
          </div>
        </div>
      </el-card>

      <!-- 分页功能 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, ->, prev, pager, next, jumper"
        :total="totalItems"
        background
        class="pagination-wrapper"
      ></el-pagination>

      <!-- 新增/编辑对话框 -->
      <el-dialog 
        v-model="dialogVisible" 
        :title="dialogTitle" 
        width="500px"
        :close-on-click-modal="false"
        class="inspection-dialog"
      >
        <el-form 
          :model="formData" 
          :rules="formRules" 
          ref="formRef"
          label-width="100px"
          class="inspection-form"
        >
          <el-form-item label="用户名" prop="userId" v-if="isAdmin">
            <el-select 
              v-model="formData.userId" 
              placeholder="请选择用户名"
              filterable
              clearable
              style="width: 100%"
              @change="handleUserChange"
              :disabled="isEdit"
              :popper-class="isSmallMobile ? 'mobile-select-dropdown' : ''"
            >
              <el-option
                v-for="user in displayedUserList"
                :key="user.userId"
                :label="user.username"
                :value="user.userId"
                class="custom-option-item"
              >
                <div class="option-content">
                  <span class="option-left">{{ user.username }}</span>
                  <span class="option-right">{{ user.purchasingUnits }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采购单位" v-if="isEdit || formData.purchasingUnits">
            <el-input 
              :value="formData.purchasingUnits" 
              disabled
            />
          </el-form-item>
          <el-form-item label="验配单位" prop="optometryClinic">
            <el-input 
              v-model="formData.optometryClinic" 
              placeholder="请输入验配单位名称"
              maxlength="255"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-form>
        
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="submitForm" :loading="submitting">
              {{ isEdit ? '更新' : '添加' }}
            </el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted, computed, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Loading } from '@element-plus/icons-vue';
import axios from 'axios';
import { useMobileDetection } from '@/utils/mobileAdapter';

const { isMobile } = useMobileDetection(768);

// 检测是否为小屏幕移动端（低于480px）
const isSmallMobile = ref(false);
const checkSmallMobile = () => {
  isSmallMobile.value = window.innerWidth <= 480;
};
onMounted(() => {
  checkSmallMobile();
  window.addEventListener('resize', checkSmallMobile);
});
onUnmounted(() => {
  window.removeEventListener('resize', checkSmallMobile);
});

// 数据列表
const inspectionList = ref([]);
const loading = ref(false);
const pageSize = ref(10);
const currentPage = ref(1);
const totalItems = ref(0);
const searchPurchasingUnits = ref('');
const searchOptometryClinic = ref('');

// 对话框状态
const dialogVisible = ref(false);
const dialogTitle = ref('');
const isEdit = ref(false);
const formRef = ref(null);
const submitting = ref(false);

// 当前登录用户ID
const currentUserId = computed(() => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    return userInfo.userId || null;
  } catch (error) {
    console.error('获取用户ID失败:', error);
    return null;
  }
});

// 判断是否是管理员
const isAdmin = computed(() => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    return userInfo.role === 'ADMIN';
  } catch (error) {
    console.error('获取用户角色失败:', error);
    return false;
  }
});

// 用户列表（管理员使用）
const userList = ref([]);
const loadingUsers = ref(false);

const displayedUserList = computed(() => {
  return userList.value;
});

// 表单数据
const formData = reactive({
  id: null,
  userId: null,
  username: '',
  purchasingUnits: '',
  optometryClinic: ''
});

// 表单验证规则
const formRules = computed(() => {
  const rules = {
    optometryClinic: [
      { required: true, message: '请输入验配单位名称', trigger: 'blur' },
      { max: 255, message: '验配单位名称长度不能超过255字符', trigger: 'blur' }
    ]
  };
  
  // 管理员模式下，用户ID必填
  if (isAdmin.value) {
    rules.userId = [
      { required: true, message: '请选择用户', trigger: 'change' }
    ];
  }
  
  return rules;
});

// 获取用户列表（管理员使用）
const fetchUserList = async () => {
  if (!isAdmin.value) {
    return;
  }
  
  loadingUsers.value = true;
  try {
    const response = await axios.get('/api/v1/admin/user', {
      params: {
        pageNum: 1,
        pageSize: 1000, // 获取所有用户
      },
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
    
    if (response.data.code === '200') {
      userList.value = response.data.data || [];
    }
  } catch (error) {
    console.error('获取用户列表失败:', error);
  } finally {
    loadingUsers.value = false;
  }
};

// 获取验配单位列表（分页）
const fetchInspectionList = async () => {
  // 管理员模式下不需要检查 currentUserId
  if (!isAdmin.value && !currentUserId.value) {
    ElMessage.error('获取用户信息失败，请重新登录');
    return;
  }
  
  loading.value = true;
  try {
    const params = {
      pageNum: currentPage.value,
      pageSize: pageSize.value,
    };
    
    // 管理员支持按采购单位、验配单位搜索；普通用户按验配单位搜索
    if (isAdmin.value) {
      if (searchPurchasingUnits.value && searchPurchasingUnits.value.trim()) {
        params.purchasingUnits = searchPurchasingUnits.value.trim();
      }
      if (searchOptometryClinic.value && searchOptometryClinic.value.trim()) {
        params.optometryClinic = searchOptometryClinic.value.trim();
      }
    } else {
      if (searchOptometryClinic.value && searchOptometryClinic.value.trim()) {
        params.optometryClinic = searchOptometryClinic.value.trim();
      }
    }
    
    // 如果是管理员，调用管理员查询接口
    const apiUrl = isAdmin.value 
      ? '/api/v1/admin/inspection-management' 
      : '/api/v1/inspection-management/list';
    
    const response = await axios.get(apiUrl, {
      params,
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
    
    if (response.data.code === '200') {
      inspectionList.value = response.data.data || [];
      totalItems.value = response.data.totalRecords ?? 0;
      currentPage.value = response.data.pageNum ?? currentPage.value;
      pageSize.value = response.data.pageSize ?? pageSize.value;
    } else {
      ElMessage.error(response.data.info || '获取验配单位列表失败');
    }
  } catch (error) {
    console.error('获取验配单位列表失败:', error);
    ElMessage.error('获取验配单位列表失败，请检查网络连接');
  } finally {
    loading.value = false;
  }
};

// 分页处理
const handleSizeChange = (val) => {
  pageSize.value = val;
  currentPage.value = 1;
  fetchInspectionList();
};

const handleCurrentChange = (val) => {
  currentPage.value = val;
  fetchInspectionList();
};

// 监听输入，实现防抖搜索
let searchTimer = null;
watch([searchPurchasingUnits, searchOptometryClinic], () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    currentPage.value = 1;
    fetchInspectionList();
  }, 500);
});

// 打开新增对话框
const openAddDialog = async () => {
  if (!isAdmin.value && !currentUserId.value) {
    ElMessage.error('获取用户信息失败，请重新登录');
    return;
  }
  
  dialogTitle.value = '新增验配单位';
  isEdit.value = false;
  formData.id = null;
  formData.userId = isAdmin.value ? null : currentUserId.value;
  formData.username = '';
  formData.purchasingUnits = '';
  formData.optometryClinic = '';
  
  // 如果是管理员，加载用户列表
  if (isAdmin.value) {
    await fetchUserList();
  } else {
    // 普通用户，获取当前用户的采购单位
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      formData.purchasingUnits = userInfo.purchasingUnits || '';
    } catch (error) {
      console.error('获取采购单位失败:', error);
    }
  }
  
  dialogVisible.value = true;
  
  // 清除表单验证
  if (formRef.value) {
    formRef.value.clearValidate();
  }
};

// 处理用户选择变化
const handleUserChange = (userId) => {
  if (!userId) {
    formData.username = '';
    formData.purchasingUnits = '';
    formData.optometryClinic = '';
    return;
  }
  
  const selectedUser = userList.value.find(u => u.userId === userId);
  if (selectedUser) {
    formData.username = selectedUser.username || '';
    formData.purchasingUnits = selectedUser.purchasingUnits || '';
  }
};


// 打开编辑对话框
const openEditDialog = async (row) => {
  dialogTitle.value = '修改验配单位';
  isEdit.value = true;
  formData.id = row.id;
  formData.userId = row.userId;
  formData.username = row.username || '';
  formData.purchasingUnits = row.purchasingUnits;
  formData.optometryClinic = row.optometryClinic;
  
  // 如果是管理员，加载用户列表
  if (isAdmin.value) {
    await fetchUserList();
  }
  
  dialogVisible.value = true;
  
  // 清除表单验证
  if (formRef.value) {
    formRef.value.clearValidate();
  }
};

// 关闭对话框
const closeDialog = () => {
  dialogVisible.value = false;
  formData.id = null;
  formData.userId = null;
  formData.username = '';
  formData.purchasingUnits = '';
  formData.optometryClinic = '';
  submitting.value = false;
  
  if (formRef.value) {
    formRef.value.clearValidate();
  }
};

// 提交表单
const submitForm = async () => {
  if (!formRef.value) {
    ElMessage.error('表单未初始化');
    return;
  }
  
  try {
    await formRef.value.validate();
    
    if (submitting.value) {
      return;
    }
    
    // 管理员模式下，使用选择的用户ID；普通用户模式下，使用当前登录用户ID
    const targetUserId = isAdmin.value ? formData.userId : currentUserId.value;
    
    if (!targetUserId) {
      ElMessage.error(isAdmin.value ? '请选择用户' : '获取用户信息失败，请重新登录');
      return;
    }
    
    submitting.value = true;
    
    // 管理员和普通用户使用相同的接口
    const url = isEdit.value ? '/api/v1/inspection-management/update' : '/api/v1/inspection-management/add';
    const method = isEdit.value ? 'put' : 'post';
    
    // 准备提交数据
    const submitData = {
      id: isEdit.value ? formData.id : undefined,
      userId: targetUserId,
      optometryClinic: formData.optometryClinic
    };
    
    // 如果是新增，移除id字段
    if (!isEdit.value) {
      delete submitData.id;
    }
    
    const response = await axios({
      method,
      url,
      data: submitData,
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
    
    if (response.data.code === '200') {
      ElMessage.success(response.data.info || (isEdit.value ? '更新成功' : '添加成功'));
      closeDialog();
      await fetchInspectionList();
    } else {
      ElMessage.error(response.data.info || '操作失败');
    }
  } catch (error) {
    if (error.message && !error.response) {
      // 表单验证失败，不显示错误
      console.log('表单验证失败');
    } else {
      console.error('提交失败:', error);
      ElMessage.error(error.response?.data?.info || '操作失败，请检查网络连接');
    }
  } finally {
    submitting.value = false;
  }
};

// 删除验配单位
const handleDelete = async (row) => {
  try {
    await ElMessageBox.confirm(
      `确定要删除验配单位"${row.optometryClinic}"吗？`,
      '确认删除',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    );
    
    const response = await axios.delete(`/api/v1/inspection-management/delete/${row.id}`, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    });
    
    if (response.data.code === '200') {
      ElMessage.success('删除成功');
      await fetchInspectionList();
    } else {
      ElMessage.error(response.data.info || '删除失败');
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除失败:', error);
      ElMessage.error(error.response?.data?.info || '删除失败，请检查网络连接');
    }
  }
};

// 格式化日期
const formatDate = (timestamp) => {
  if (!timestamp) return '';
  
  try {
    // 处理字符串格式的日期 "yyyy-MM-dd HH:mm:ss"
    let date;
    if (typeof timestamp === 'string') {
      // 替换空格为 'T' 以符合 ISO 8601 格式，提高兼容性
      const isoString = timestamp.replace(' ', 'T');
      date = new Date(isoString);
      
      // 如果解析失败，尝试直接解析原字符串
      if (isNaN(date.getTime())) {
        date = new Date(timestamp);
      }
    } else {
      date = new Date(timestamp);
    }
    
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      console.warn('Invalid date:', timestamp);
      return '-';
    }
    
    // 使用更详细的格式化选项，确保跨平台兼容性
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  } catch (error) {
    console.error('Date formatting error:', error, timestamp);
    return '-';
  }
};

// 页面初始化
onMounted(() => {
  if (isAdmin.value || currentUserId.value) {
    fetchInspectionList();
  } else {
    ElMessage.error('获取用户信息失败，请重新登录');
  }
});
</script>

<style scoped>
.inspection-management {
  padding: 20px;
}

.content {
  max-width: 1300px;
  margin: 0 auto;
}

.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.optometry-clinic-text {
  font-weight: 500;
  color: #409EFF;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  align-items: center;
}

/* 手机端卡片式布局 */
.mobile-cards {
  width: 100%;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  font-size: 14px;
  color: #909399;
}

.loading-container .el-icon {
  margin-right: 5px;
  font-size: 18px;
}

.inspection-card {
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 10px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.card-title {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}

.card-details {
  margin-bottom: 12px;
}

.detail-item {
  display: flex;
  margin-bottom: 8px;
  align-items: flex-start;
}

.detail-item.highlight {
  background-color: #f0f9ff;
  padding: 8px;
  border-radius: 4px;
  margin: 8px 0;
}

.detail-item .label {
  width: 90px;
  color: #909399;
  font-size: 13px;
  flex-shrink: 0;
}

.detail-item .value {
  flex: 1;
  color: #303133;
  font-size: 13px;
  word-break: break-all;
}

.detail-item.highlight .value {
  font-weight: 500;
  color: #409EFF;
}

.card-actions {
  display: flex;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #EBEEF5;
}

.header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-bar .title {
  font-size: 16px;
  font-weight: 600;
}

.header-search {
  width: 180px;
}

.header-add-btn {
  margin-left: auto;
}

.inspection-form {
  padding: 20px 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* 分页器样式 */
.pagination-wrapper {
  margin-top: 20px;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
}

.option-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.option-left {
  font-weight: normal;
  color: #606266;
  margin-right: 10px;
  /* 防止过长挤压 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.option-right {
  color: #8492a6;
  font-size: 13px;
  /* 防止过长 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px; /* 移动端限制宽度 */
  text-align: right;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .inspection-management {
    padding: 10px;
  }

  :deep(.el-pagination__jump) {
    display: none !important;
  }
  :deep(.el-pagination__total){
    display: none !important;
  }
  :deep(.el-pagination__rightwrapper){
    justify-content: center;
  }

  :deep(.el-form-item__label){
    display: block !important;
  }
  
  .el-card :deep(.el-card__header) {
    padding: 12px 15px;
  }
  
  .el-card :deep(.el-card__body) {
    padding: 12px;
  }

  .action-buttons {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .action-buttons .el-button {
    margin: 3px 0;
    width: 100%;
  }

  .inspection-card {
    padding: 10px;
    margin-bottom: 8px;
  }
  
  .card-header {
    margin-bottom: 8px;
    padding-bottom: 8px;
  }
  
  .card-title {
    font-size: 15px;
  }
  
  .detail-item .label,
  .detail-item .value {
    font-size: 12px;
  }

  .detail-item .label {
    width: 80px;
  }
  
  .card-actions .el-button {
    font-size: 12px;
    padding: 5px 8px;
    height: 32px;
  }

  .inspection-dialog {
    width: 95% !important;
    max-width: 95vw !important;
  }

  .inspection-form {
    padding: 10px 0;
  }

  :deep(.el-form-item__label) {
    font-size: 14px;
    min-width: 80px;
  }

  :deep(.el-input__inner) {
    font-size: 14px;
  }

  .pagination-wrapper {
    padding: 8px 5px;
  }
}

@media screen and (max-width: 480px) {
  :deep(.el-form-item) {
    flex-direction: column;
  }
  .inspection-management {
    padding: 8px;
  }
  
  .el-card :deep(.el-card__header) {
    padding: 10px;
    font-size: 16px;
  }
  
  .el-card :deep(.el-card__body) {
    padding: 8px;
  }
  
  .inspection-card {
    padding: 8px;
    margin-bottom: 6px;
  }
  
  .card-header {
    margin-bottom: 6px;
    padding-bottom: 6px;
  }
  
  .card-title {
    font-size: 14px;
  }
  
  .detail-item .label {
    width: 70px;
    font-size: 11px;
  }
  
  .detail-item .value {
    font-size: 11px;
  }
  
  .card-actions {
    flex-direction: column;
    gap: 5px;
  }
  
  .card-actions .el-button {
    width: 100%;
    margin: 0;
    padding: 4px 6px;
    font-size: 11px;
    height: 30px;
  }

  .inspection-dialog {
    width: 98% !important;
  }

  :deep(.el-dialog__header) {
    padding: 12px;
  }

  :deep(.el-dialog__body) {
    padding: 12px;
  }

  :deep(.el-dialog__footer) {
    padding: 12px;
  }
}

@media screen and (max-width: 320px) {
  .inspection-management {
    padding: 5px;
  }
  
  .el-card :deep(.el-card__header) {
    padding: 8px;
    font-size: 15px;
  }
  
  .el-card :deep(.el-card__body) {
    padding: 5px;
  }
  
  .inspection-card {
    padding: 6px;
  }
  
  .card-title {
    font-size: 13px;
  }
  
  .detail-item .label {
    width: 65px;
    font-size: 10px;
  }
  
  .detail-item .value {
    font-size: 10px;
  }
  
  .card-actions .el-button {
    font-size: 10px;
    padding: 3px 5px;
    height: 28px;
  }
}

</style>
